/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ScanJob } from '../models/ScanJob';

export class ListScanJobsResponse {
  'jobs': Array<ScanJob>;
  'nextToken'?: string;
  /**
  * The total number of jobs
  */
  'totalCount': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobs",
      "baseName": "jobs",
      "type": "Array<ScanJob>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListScanJobsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

